export interface ProsesStep {
  urutan: number;
  nama_step: string;
  harga_borongan: number;
}

export interface ProsesProduksi {
  id?: number | string;
  kode?: string;
  nama_proses: string;
  keterangan: string;
  is_aktif: boolean;
  steps: ProsesStep[];
}

export const emptyStep = (urutan: number): ProsesStep => ({
  urutan,
  nama_step: '',
  harga_borongan: 0,
});
